export const initializeBackButton = () => {
    const backButton = document.querySelector('.js-back-button');
    if (!backButton) {
        return;
    }

    backButton.addEventListener('click', (e) => {
        e.preventDefault();
        window.history.back();
    });
};
